import React, { useState, useEffect } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls';
import {
	Button,
	TextField,
	MuiThemeProvider,
	createMuiTheme,
	FormControlLabel,
	Checkbox,
	MenuItem,
	FormControl,
	InputLabel,
	Select,
	FormHelperText,
	Tooltip
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import {
	deleteUser,
	getAIModels,
	getUserById,
	postUser,    
	updateUser,
} from '../../../../api/user';
import { useSkeleton } from '../../../hooks/useSkeleton';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { ArrowUpward, ArrowDownward, Visibility } from '@material-ui/icons'
import PreviewDialog from "../../../components/dialogs/PreviewDialog"
import { SERVER_URL } from "../../../../api/index"
import DeleteIcon from '@material-ui/icons/Delete'
import { buttonsStyle } from '../../../components/tables/table'
import Editor from '../../../components/editor/Editor'
import { useSelector, shallowEqual } from "react-redux";
import { getNonEmpty } from '../../../../utils/helpers';

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: '#F64E60',
		},
	},
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};


function getEmptyTeacher() {

	return {
		fullName: '',
		email: '',
		role: 'teacher',
		phone: '',
		birthdate: null,
		imagesURLs: [],
		priceHour: '',
		skills: '',
		password: '',
		repeatPassword: '',
		certifications: [],
		specializations: [],
		status: 'active'
	};
}

export default function EditTeachersPage() {
	const [teacher, setTeacher] = useState(getEmptyTeacher());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [selectedImages, setSelectedImages] = useState(null)
	const [deletedImages, setDeletedImages] = useState(null)
	const [openPreviewDialog, setOpenPreviewDialog] = useState(null)
	const [newPassword, setNewPassword] = useState({ password: null, repeatPassword: null })
	const [changePassword, setChangePassword] = useState(false)
	const teacherId = useParams().id;
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!teacherId) {
			disableLoadingData();
			return;
		}
		getUserById(teacherId)
			.then((res) => {
				if (res.status === 200) {
					const teacher = res.data;
					delete teacher.password;
					setTeacher(teacher);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get teacher.' });
				history.push('/teachers');
			});
	}, [teacherId, disableLoadingData, history]);

	function saveTeacher() {
		let saveTeacher = teacher
		if (!teacherId || changePassword) {
		  if (!newPassword.password || !newPassword.repeatPassword) {
			alertError({ error: null, customMessage: 'Please enter the password.' })
			return
		  }
		  if (newPassword.password !== newPassword.repeatPassword) {
			alertError({ error: null, customMessage: 'Passwords do not match.' })
			return
		  }
		  saveTeacher = {...saveTeacher, password: newPassword.password }
		}
		if (typeof saveTeacher.priceHour === 'string') {
			saveTeacher.priceHour = saveTeacher.priceHour.includes(',') ? saveTeacher.priceHour.replace(',', '.') : saveTeacher.priceHour
			if (isNaN(saveTeacher.priceHour)) {
			  alertError({ error: null, customMessage: 'Price/Hour should be a number.' })
			  return
			}
			saveTeacher.priceHour = parseFloat(saveTeacher.priceHour)
		}
		if (!teacherId) {
			postUser(saveTeacher, selectedImages)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: 'Saved!',
							customMessage: 'Teacher successfully created.',
						});
						history.push('/teachers');
					}
				})
				.catch((error) => {
					alertError({ error: error, customMessage: 'Could not save teacher.' });
				});
		} else {
			updateUser(teacherId, saveTeacher, selectedImages)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: 'Saved!',
							customMessage: 'Changes successfully saved.',
						});
						history.push('/teachers');
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: 'Could not save changes.',
					});
				});
		}
	}

	const handleChange = (element, day) => (event) => {
		setTeacher({ ...teacher, [element]: event.target.value });
	};

	const handleChangeEditor = (element, value) => {
		setTeacher({ ...teacher, [element]: value })
	  }


	const handleDeleteImage = (index) => {
		// TODO: DELETE IMAGES FROM SERVER
		let newImages = [...teacher.imagesURLs]
		const deletedImage = newImages.splice(index, 1)
		setTeacher({ ...teacher, imagesURLs: newImages })
		if (selectedImages && selectedImages[index]) {
		  let _selectedImages = {}
		  for (const [key, value] of Object.entries(selectedImages)) {
			if (key !== index) {
			  if (key > index) {
				_selectedImages[key - 1] = value
			  } else _selectedImages[key] = value
			} 
		  }
		  if (!Object.keys(_selectedImages).length) _selectedImages = null
		  setSelectedImages(_selectedImages)
		} else setDeletedImages(deletedImages ? deletedImages.concat(deletedImage) : [deletedImage])
	  }
	
	  const handleMoveImage = (index, newIndex) => {
		const aux = teacher.imagesURLs[index]
		let images = [...teacher.imagesURLs]
		images.splice(index, 1, images[newIndex])
		images.splice(newIndex, 1, aux)
		setTeacher({ ...teacher, imagesURLs: images })
		if (selectedImages && (selectedImages[index] || selectedImages[newIndex])) {
		  let _selectedImages = {}
		  for (const [key, value] of Object.entries(selectedImages)) {
			if (key === index.toString()) _selectedImages[newIndex] = value
			else if (key === newIndex.toString()) _selectedImages[index] = value
			else _selectedImages[key] = value
		  }
		  setSelectedImages(_selectedImages)
		}
	  }

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title='Edit teacher'></CardHeader>
					<CardBody>
						<TextField
							id={`fullName`}
							label='Full name'
							value={teacher.fullName}
							onChange={handleChange('fullName')}
							InputLabelProps={{
								shrink: true,
							}}
							margin='normal'
							variant='outlined'
							required
						/>
						<TextField
							id={`email`}
							label='Email'
							value={teacher.email}
							onChange={handleChange('email')}
							InputLabelProps={{
								shrink: true,
							}}
							margin='normal'
							variant='outlined'
							required
						/>
						<br />
						<br />
						<TextField
							id={`phone`}
							label="Phone"
							value={teacher.phone}
							onChange={handleChange('phone')}
							InputLabelProps={{
								shrink: true
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<br/>
						<Editor
							body={teacher.skills || ''}
							setBody={new_body => handleChangeEditor('skills', new_body)}
							className='max-height'
							placeholder={'Enter skills description here...'}
							label="Skills"
						/>
						<br/>
						{(!teacherId || changePassword) ? <>
							<br />
							<br />
							<TextField
								id={`password`}
								label="Password"
								value={newPassword.password}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, password: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							<TextField
								id={`repeatPassword`}
								label="Repeat password"
								value={newPassword.repeatPassword}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, repeatPassword: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							<br/>
							<br/>
							{teacherId && <>
								<Button
									onClick={() => {
										setChangePassword(false)
										setNewPassword({ password: null, repeatPassword: null })
									}}
									variant="outlined"
									style={{ marginRight: '20px' }}
								>
									Cancel change password
								</Button>
								<br />
								<br />  
							</>}
							</> : <>
							<br />
							<br />
							<Button
								onClick={() => setChangePassword(true)}
								variant="outlined"
								color="primary"
								style={{ marginRight: '20px' }}>
								Change password
							</Button>
							<br />
							<br />
						</>}
						{teacher.imagesURLs?.map((_, index) => {
							return (
							<>
								<label htmlFor={"upload-image" + index}>
									<input
										style={{ display: 'none' }}
										id={"upload-image" + index}
										name={"upload-image" + index}
										type="file"
										accept={'image/*'}
										onChange={(e) => {
											setSelectedImages({ ...selectedImages, [index]: e.target.files[0] })
										}}
									/>
									<Button
										style={{ marginRight: '15px' }}
										color="secondary"
										component="span"
										variant="outlined">
										{((selectedImages && selectedImages[index]) || teacher.imagesURLs[index] !== '') ? 'Change image ' + (index + 1) : 'Upload image ' + (index + 1)}
									</Button>
								</label>
								{((selectedImages && selectedImages[index]) || teacher.imagesURLs[index] !== '') &&
								<>
									<Tooltip title={'Preview image ' + (index + 1)}>
										<Button
											size="small"
											onClick={() => setOpenPreviewDialog(index)}
											style={buttonsStyle}>
											<Visibility/>
										</Button>
									</Tooltip>
									<PreviewDialog
										title={'Preview image ' + (index + 1)}
										open={openPreviewDialog === index}
										setOpen={setOpenPreviewDialog}
										src={(selectedImages && selectedImages[index]) ? URL.createObjectURL(selectedImages[index]) : `${SERVER_URL}/${teacher.imagesURLs[index]}`}
									/>
									<Tooltip title="Delete">
										<Button
											size="small"
											style={buttonsStyle}
											onClick={() => handleDeleteImage(index)}>
											<DeleteIcon/>
										</Button>
									</Tooltip>
									<Tooltip title="Move up">
										<Button
											size="small"
											style={buttonsStyle}
											disabled={index === 0}
											onClick={() => handleMoveImage(index, index - 1)}>
											<ArrowUpward/>
										</Button>
									</Tooltip>
									<Tooltip title="Move down">
										<Button
											size="small"
											disabled={!(index < teacher.imagesURLs.length - 1 && ((selectedImages && selectedImages[index + 1]) || teacher.imagesURLs[index + 1] !== ''))}
											style={{...buttonsStyle, marginRight: '1em' }}
											onClick={() => handleMoveImage(index, index + 1)}>
											<ArrowDownward/>
										</Button>
									</Tooltip>
									<span>
										{selectedImages && selectedImages[index] ? selectedImages[index]?.name : (teacher.imagesURLs[index] !== '' ? teacher.imagesURLs[index].split(/-(.*)/s)[1] : '')}
									</span>
									<br />
								</>
								}
							</>
							)
						})}
						<br />
						<br />
						<Button
							variant="outlined"
							color="primary"
							onClick={() => setTeacher({ ...teacher, imagesURLs: teacher.imagesURLs.concat('') })}
						>
							Add image
						</Button>
						<br/>
						<br/>
					</CardBody>
				</Card>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Button
						onClick={() => history.push('/teachers')}
						variant='outlined'
						style={{ marginRight: '20px' }}>
						Back
					</Button>
					<Button
						onClick={() => saveTeacher()}
						variant='outlined'
						color='primary'
						style={{ marginRight: '20px' }}>
						Save teacher
					</Button>
					{teacherId && user?.role.includes('admin') && (
						<>
							<MuiThemeProvider theme={theme}>
								<Button
									onClick={() => setOpenConfirmDialog(true)}
									variant='outlined'
									color='secondary'
									style={{ marginRight: '20px' }}>
									Delete teacher
								</Button>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										marginLeft: 'auto',
									}}></div>
							</MuiThemeProvider>

							<ConfirmDialog
								title={'Are you sure you want to delete this teacher?'}
								open={openConfirmDialog}
								setOpen={setOpenConfirmDialog}
								onConfirm={() => {
									deleteUser(teacherId)
										.then((res) => {
											if (res.status === 204 || res.status === 200) {
												alertSuccess({
													title: 'Deleted!',
													customMessage: 'Teacher deleted successfully',
												});
												history.push('/teachers');
											}
										})
										.catch((error) => {
											alertError({
												error: error,
												customMessage: 'Could not delete teacher.',
											});
										});
								}}
							/>
						</>
					)}
				</div>
			</>
		);
}
